export const inputCls = "w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-brand";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");

export const fmtSlot = (slot) =>
  slot ? new Date(slot).toLocaleString("fr-FR", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" }) : "—";

export const INTENTS = {
  rdv: { label: "Rendez-vous", cls: "bg-emerald-100 text-emerald-700" },
  confirmation: { label: "Confirmation de RDV", cls: "bg-emerald-200 text-emerald-800" },
  report: { label: "Demande de report", cls: "bg-orange-100 text-orange-700" },
  devis: { label: "Demande de devis", cls: "bg-blue-100 text-blue-700" },
  question: { label: "Question", cls: "bg-sky-100 text-sky-700" },
  refus: { label: "Refus", cls: "bg-neutral-200 text-neutral-700" },
  desabonnement: { label: "Désabonnement", cls: "bg-amber-100 text-amber-700" },
  spam: { label: "Spam", cls: "bg-neutral-100 text-neutral-500" },
  autre: { label: "Autre", cls: "bg-neutral-100 text-neutral-600" },
};

export const STATUS = {
  nouveau: { label: "Nouveau", cls: "bg-brand/10 text-brand" },
  analyse: { label: "Analysé par l'IA", cls: "bg-violet-100 text-violet-700" },
  repondu: { label: "Répondu", cls: "bg-sky-100 text-sky-700" },
  rdv_planifie: { label: "RDV planifié", cls: "bg-emerald-100 text-emerald-700" },
  rdv_confirme: { label: "RDV confirmé", cls: "bg-emerald-600 text-white" },
  erreur: { label: "Erreur IA", cls: "bg-red-100 text-red-700" },
};

export const Badge = ({ map, value, testid }) => {
  const m = map[value] || { label: value, cls: "bg-neutral-100 text-neutral-600" };
  return <span data-testid={testid} className={`inline-block text-[11px] font-semibold px-2 py-0.5 rounded-full ${m.cls}`}>{m.label}</span>;
};
